export const itIT = {
  lang: 'it-IT',
  country: 'IT',
  flag: '\u{1F1EE}\u{1F1F9}',
  currency: '\u20AC',

  app: {
    sidebar: {
      dashboard: 'Dashboard',
      transactions: 'Transazioni',
      pots: 'Salvadanai',
      receipts: 'Scontrini',
      reports: 'Report',
      categories: 'Categorie',
      tags: 'Tag',
      budgets: 'Budget',
      recurring: 'Ricorrenti',
      settings: 'Impostazioni',
      darkMode: 'Tema Scuro',
      lightMode: 'Tema Chiaro',
      logout: 'Esci',
    },
    common: {
      loading: 'Caricamento...',
      save: 'Salva',
      cancel: 'Annulla',
      confirmTitle: 'Conferma',
      delete: 'Elimina',
      edit: 'Modifica',
      create: 'Crea',
      search: 'Cerca',
      filter: 'Filtri',
      export: 'Esporta',
      type: 'Tipo',
      category: 'Categoria',
      date: 'Data',
      amount: 'Importo',
      description: 'Descrizione',
      actions: 'Azioni',
      income: 'Entrata',
      expense: 'Uscita',
      name: 'Nome',
      color: 'Colore',
      confirmDelete: 'Sei sicuro di voler eliminare?',
      noResults: 'Nessun risultato trovato',
      status: 'Stato',
      error: 'Errore',
      success: 'Successo',
      page: 'Pagina',
      of: 'di',
      showing: 'Visualizzando',
      viewDetails: 'Vedi dettagli',
      tags: 'Tag',
      receipt: 'Scontrino',
      receiptAttached: 'Scontrino allegato',
    },
    categoryLabels: {
      food: 'Alimentazione',
      transport: 'Trasporto',
      shopping: 'Shopping',
      entertainment: 'Intrattenimento',
      health: 'Salute',
      education: 'Istruzione',
      utilities: 'Bollette',
      housing: 'Alloggio',
      travel: 'Viaggio',
      other: 'Altro',
      salary: 'Stipendio',
      investment: 'Investimento',
      freelance: 'Freelance',
      gift: 'Regalo',
    },
    tags: {
      loading: 'Caricamento tag...',
      error: 'Impossibile caricare i tag. Riprova.',
      title: 'Tag',
      subtitle: 'Crea tag per organizzare e filtrare le tue transazioni',
      newTag: 'Nuovo Tag',
      noTags: 'Nessun tag creato',
      noTagsDescription: 'I tag vengono creati automaticamente quando usi #tag nei tuoi messaggi, oppure puoi crearli manualmente qui.',
      createFirst: 'Crea il primo tag',
      howToUse: 'Come usare i tag',
      howToUseDescription: 'Aggiungi tag alle tue transazioni via WhatsApp usando #tag. Ad esempio: "Pranzo 35 euro #lavoro #pranzo". I tag aiutano a filtrare e analizzare le tue spese.',
      form: {
        name: 'Nome del tag',
        namePlaceholder: 'lavoro, viaggio, pranzo...',
        nameHint: 'Verr\u00E0 convertito in minuscolo senza spazi',
        color: 'Colore',
      },
      stats: {
        title: 'Statistiche',
        created: 'Tag creati',
        totalUsage: 'Utilizzi totali',
        mostUsed: 'Pi\u00F9 usato',
        unused: 'Non utilizzato',
      },
      confirmDelete: 'Elimina Tag',
      deleteWarning: 'Sei sicuro di voler eliminare il tag',
      deleteUsageWarning: 'Questo tag \u00E8 usato in {count} transazioni. Il tag verr\u00E0 rimosso da queste transazioni.',
    },
    pots: {
      title: 'Salvadanai',
      subtitle: 'Organizza i tuoi soldi in diversi salvadanai per valuta',
      loading: 'Caricamento salvadanai...',
      error: 'Impossibile caricare i salvadanai. Riprova.',
      errorTitle: 'Errore nel caricamento dei salvadanai',
      newPot: 'Nuovo Salvadanaio',
      editPot: 'Modifica Salvadanaio',
      noPots: 'Nessun salvadanaio creato',
      noPotsDescription: 'Crea salvadanai per organizzare i tuoi soldi per valuta o obiettivo.',
      createFirst: 'Crea il primo salvadanaio',
      setDefault: 'Imposta come predefinito',
      transactions: 'transazioni',
      confirmDelete: 'Elimina Salvadanaio',
      confirmDeleteMessage: 'Sei sicuro di voler eliminare il salvadanaio',
      deleteWarning: 'Questo salvadanaio ha {count} transazioni che verranno spostate nel salvadanaio predefinito.',
      form: {
        name: 'Nome',
        namePlaceholder: 'Es: Fondo emergenza',
        description: 'Descrizione (opzionale)',
        descriptionPlaceholder: 'A cosa serve questo salvadanaio?',
        currency: 'Valuta',
        color: 'Colore',
      },
    },
    transactions: {
      loading: 'Caricamento transazioni...',
      title: 'Transazioni',
      subtitle: 'Gestisci le tue entrate e uscite',
      searchPlaceholder: 'Cerca per descrizione, esercente...',
      showing: 'Visualizzando {count} di {total} transazioni',
      confirmDelete: 'Sei sicuro di voler eliminare questa transazione?',
      filters: {
        filters: 'Filtri',
        dateStart: 'Data Inizio',
        dateEnd: 'Data Fine',
        startDate: 'Data Inizio',
        endDate: 'Data Fine',
        minAmount: 'Importo Minimo',
        maxAmount: 'Importo Massimo',
      },
      table: {
        description: 'Descrizione',
        category: 'Categoria',
        date: 'Data',
        amount: 'Importo',
        receipt: 'Ricevuta',
        actions: 'Azioni',
      },
      viewReceipt: 'Visualizza ricevuta',
      modal: {
        editTitle: 'Modifica Transazione',
        detailsTitle: 'Dettagli Transazione',
        merchant: 'Esercente',
        description: 'Descrizione',
        tags: 'Tag',
        receipt: 'Scontrino',
        receiptAttached: 'Scontrino allegato',
        createCategory: 'Crea nuova categoria',
      },
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Panoramica delle tue finanze',
      period: {
        week: 'Settimana',
        month: 'Mese',
        year: 'Anno',
      },
      cards: {
        income: 'Entrate',
        expense: 'Uscite',
        expenses: 'Uscite',
        balance: 'Saldo',
        transactions: 'Transazioni',
      },
      charts: {
        spending: 'Spese per Categoria',
        trend: 'Tendenza',
        byCategory: 'Spese per Categoria',
      },
      recent: 'Transazioni Recenti',
      viewAll: 'Vedi tutte',
      topCategories: 'Categorie Principali',
      items: 'elementi',
      loading: 'Caricamento dashboard...',
    },
    settings: {
      title: 'Impostazioni',
      subtitle: 'Gestisci il tuo profilo e le preferenze',
      profile: {
        title: 'Profilo',
        phone: 'Telefono',
        phoneVerified: 'Verificato',
        phoneHint: 'Il telefono viene usato per l\'autenticazione e non pu\u00F2 essere modificato qui.',
        name: 'Nome',
        namePlaceholder: 'Il tuo nome',
        email: 'Email',
        emailPlaceholder: 'tua@email.com',
        emailHint: 'Usato per ricevere report e notifiche.',
        verified: 'Verificato',
      },
      preferences: {
        title: 'Preferenze',
        language: 'Lingua',
        languageHint: 'Lingua usata nei messaggi WhatsApp e nei report.',
        timezone: 'Fuso Orario',
      },
      subscription: {
        title: 'Abbonamento',
        plan: 'Piano',
        status: {
          active: 'Attivo',
          trialing: 'Prova',
          pastDue: 'Pagamento in Sospeso',
          past_due: 'Pagamento in Sospeso',
          canceled: 'Cancellato',
          expired: 'Scaduto',
        },
        trialEnds: 'La prova termina il',
        trialEndsAt: 'La prova termina il',
        nextBilling: 'Prossima fatturazione',
        upgrade: 'Passa a Premium',
        support: 'Contatta il Supporto',
        contactSupport: 'Contatta il Supporto',
        cancel: 'Cancella abbonamento',
        noSubscription: 'Nessun abbonamento attivo',
        noSubscriptionDesc: 'Abbonati a un piano per sbloccare tutte le funzionalit\u00E0.',
        viewPlans: 'Vedi Piani',
        plans: {
          free: 'Gratuito',
          basic: 'Basic',
          starter: 'Starter',
          pro: 'Pro',
          professional: 'Professional',
          enterprise: 'Enterprise',
          vip: 'VIP',
        },
      },
      account: {
        title: 'Informazioni Account',
        id: 'ID account',
        createdAt: 'Account creato il',
      },
      saveChanges: 'Salva Modifiche',
      loading: 'Caricamento impostazioni...',
      error: 'Errore nel caricamento delle impostazioni',
      errorDesc: 'Impossibile caricare le tue informazioni. Riprova.',
    },
    budgets: {
      title: 'Budget',
      subtitle: 'Imposta limiti di spesa per categoria',
      loading: 'Caricamento budget...',
      error: 'Errore nel caricamento dei budget',
      errorDesc: 'Impossibile caricare i tuoi budget. Riprova.',
      newBudget: 'Nuovo Budget',
      noBudgets: 'Nessun budget impostato',
      noBudgetsDesc: 'Crea budget per controllare le tue spese per categoria e ricevere avvisi.',
      createFirst: 'Crea il primo budget',
      period: {
        monthly: 'Mensile',
        yearly: 'Annuale',
      },
      status: {
        safe: 'Nei limiti',
        warning: 'Vicino al limite',
        danger: 'Limite superato!',
      },
      spent: 'speso',
      limit: 'Limite',
      remaining: 'Rimanente',
      exceeded: 'Superato',
      summary: {
        totalBudgeted: 'Totale Budget',
        totalSpent: 'Totale Speso',
        overBudget: 'Oltre il Limite',
        budget: 'budget',
        budgets: 'budget',
      },
      tips: {
        title: 'Consigli per un buon budget',
        tip1: 'Inizia con le categorie dove spendi di più',
        tip2: 'Imposta limiti realistici basati sulla tua storia',
        tip3: 'Usa l\'avviso all\'80% per agire prima di superare',
        tip4: 'Rivedi i tuoi budget mensilmente',
      },
      confirmDelete: 'Elimina Budget',
      confirmDeleteMsg: 'Sei sicuro di voler eliminare il budget',
      form: {
        newBudget: 'Nuovo Budget',
        editBudget: 'Modifica Budget',
        budgetName: 'Nome del budget',
        budgetNamePlaceholder: 'Es: Alimentazione mensile, Trasporto...',
        category: 'Categoria (opzionale)',
        allExpenses: 'Tutte le spese',
        limit: 'Limite',
        period: 'Periodo',
        alertThreshold: 'Avvisa al raggiungimento di',
        alertDescription: 'Sarai avvisato quando le tue spese raggiungeranno questa percentuale del limite.',
        preview: 'Anteprima',
        save: 'Salva',
        create: 'Crea',
      },
    },
    categories: {
      title: 'Categorie',
      subtitle: 'Gestisci le tue categorie di entrate e spese',
      loading: 'Caricamento categorie...',
      error: 'Errore nel caricamento delle categorie',
      errorDesc: 'Impossibile caricare le tue categorie. Riprova.',
      newCategory: 'Nuova Categoria',
      myCategories: 'Le Mie Categorie',
      systemCategories: 'Categorie di Sistema',
      systemCategoriesDesc: 'Queste categorie sono predefinite e non possono essere modificate.',
      noCustomCategories: 'Nessuna categoria personalizzata',
      noCustomCategoriesDesc: 'Crea categorie personalizzate per organizzare meglio le tue finanze.',
      createFirst: 'Crea la prima categoria',
      type: {
        income: 'Entrata',
        expense: 'Spesa',
      },
      deductible: 'Deducibile',
      confirmDelete: 'Elimina Categoria',
      confirmDeleteMsg: 'Sei sicuro di voler eliminare la categoria',
      deleteWarning: 'Le transazioni esistenti verranno spostate in "Altro".',
      form: {
        newCategory: 'Nuova Categoria',
        editCategory: 'Modifica Categoria',
        categoryName: 'Nome della categoria',
        categoryNamePlaceholder: 'Es: Alimentazione, Trasporto...',
        type: 'Tipo',
        icon: 'Icona',
        colour: 'Colore',
        preview: 'Anteprima',
        taxDeductible: 'Deducibile dalle tasse',
        save: 'Salva',
        create: 'Crea',
      },
    },
    receipts: {
      title: 'Ricevute',
      subtitle: 'Visualizza e gestisci i tuoi documenti fiscali',
      loading: 'Caricamento ricevute...',
      error: 'Errore nel caricamento delle ricevute',
      errorDesc: 'Impossibile caricare le tue ricevute. Riprova.',
      status: {
        all: 'Tutti gli Stati',
        processing: 'In elaborazione',
        completed: 'Completate',
        failed: 'Fallite',
        manual_review: 'Revisione Manuale',
      },
      year: {
        all: 'Tutti gli Anni',
      },
      stats: {
        total: 'Totale',
        completed: 'Completate',
        processing: 'In elaborazione',
        failed: 'Fallite',
      },
      noReceipts: 'Nessuna ricevuta',
      noReceiptsFiltered: 'Nessuna ricevuta trovata',
      noReceiptsDesc: 'Invia una foto di ricevuta via WhatsApp per iniziare',
      noReceiptsFilteredDesc: 'Regola i filtri per vedere più ricevute',
      showing: 'Visualizzazione di {count} su {total} ricevute',
      page: 'Pagina {current} di {total}',
    },
    recurring: {
      title: 'Transazioni Ricorrenti',
      subtitle: 'Automatizza le tue spese e entrate fisse',
      loading: 'Caricamento transazioni ricorrenti...',
      error: 'Errore nel caricamento delle transazioni ricorrenti',
      errorDesc: 'Impossibile caricare le tue transazioni ricorrenti. Riprova.',
      newRecurring: 'Nuova Ricorrente',
      noRecurring: 'Nessuna transazione ricorrente',
      noRecurringDesc: 'Configura transazioni che si ripetono automaticamente, come affitto, abbonamenti o stipendio.',
      createFirst: 'Crea la prima ricorrente',
      active: 'Attiva',
      paused: 'In pausa',
      activeCount: 'Attive ({count})',
      pausedCount: 'In pausa ({count})',
      next: 'Prossima',
      summary: {
        monthlyExpenses: 'Spese Mensili',
        monthlyIncome: 'Entrate Mensili',
        netMonthly: 'Saldo Mensile',
      },
      frequency: {
        daily: 'Giornaliera',
        weekly: 'Settimanale',
        monthly: 'Mensile',
        yearly: 'Annuale',
      },
      dayOf: {
        everyDay: 'Ogni giorno',
        every: 'Ogni',
        dayOfMonth: 'Il giorno {day}',
        annually: 'Annualmente',
      },
      actions: {
        pause: 'Metti in pausa',
        activate: 'Attiva',
        processNow: 'Elabora ora',
      },
      tips: {
        title: 'Informazioni sulle Transazioni Ricorrenti',
        tip1: 'Le transazioni vengono create automaticamente alla data programmata',
        tip2: 'Puoi mettere in pausa temporaneamente senza eliminare',
        tip3: 'Usa per spese fisse come affitto, luce, internet',
        tip4: 'Funziona anche per entrate come stipendio',
      },
      confirmDelete: 'Elimina Transazione Ricorrente',
      confirmDeleteMsg: 'Sei sicuro di voler eliminare la transazione ricorrente',
      deleteWarning: 'Le transazioni già create non saranno interessate.',
      form: {
        newRecurring: 'Nuova Transazione Ricorrente',
        editRecurring: 'Modifica Transazione Ricorrente',
        description: 'Descrizione',
        descriptionPlaceholder: 'Es: Affitto, Netflix, Stipendio...',
        amount: 'Importo',
        category: 'Categoria',
        selectCategory: 'Seleziona una categoria',
        selectPot: 'Seleziona un salvadanaio (opzionale)',
        frequencyLabel: 'Frequenza',
        dayOfMonth: 'Giorno del mese',
        dayOfWeek: 'Giorno della settimana',
        day: 'Giorno',
        startDate: 'Data di inizio',
        endDate: 'Data di fine (opzionale)',
        preview: 'Anteprima',
        save: 'Salva',
        create: 'Crea',
        daysOfWeek: {
          monday: 'Lunedì',
          tuesday: 'Martedì',
          wednesday: 'Mercoledì',
          thursday: 'Giovedì',
          friday: 'Venerdì',
          saturday: 'Sabato',
          sunday: 'Domenica',
        },
      },
    },
    reports: {
      title: 'Report Fiscali',
      subtitle: 'Riepiloghi annuali per la dichiarazione dei redditi',
      loading: 'Caricamento report...',
      error: 'Errore nel caricamento dei report',
      errorDesc: 'Impossibile caricare i tuoi report. Riprova.',
      year: {
        all: 'Tutti gli anni',
      },
      noReports: 'Nessun report',
      noReportsFiltered: 'Nessun report trovato',
      noReportsDesc: 'I tuoi report fiscali appariranno qui alla fine di ogni anno.',
      noReportsFilteredDesc: 'Non ci sono report per l\'anno {year}.',
      generatedOn: 'Generato il',
      card: {
        income: 'Entrate',
        expenses: 'Spese',
        deductible: 'Deducibili',
        balance: 'Saldo',
      },
      country: {
        BR: 'Brasile',
        GB: 'Regno Unito',
      },
      tips: {
        title: 'Informazioni sui Report Fiscali',
        desc: 'I report vengono generati automaticamente alla fine di ogni anno fiscale.',
        tip1: 'Brasile: Anno fiscale da gennaio a dicembre',
        tip2: 'Regno Unito: Anno fiscale da aprile a marzo',
      },
    },
  },

  nav: {
    pricing: 'Prezzi',
    features: 'Funzionalit\u00E0',
    howItWorks: 'Come Funziona',
    login: 'Accedi',
  },

  hero: {
    badge: 'Gestione finanziaria senza attriti',
    title: 'Organizza le tue finanze via WhatsApp',
    subtitle: 'Invia un messaggio, una foto o un audio. L\'IA registra, categorizza e organizza tutto per te.',
    cta: 'Inizia Gratis',
    ctaSubtext: '14 giorni gratis, senza carta',
    ukOnly: 'Disponibile solo per numeri del Regno Unito al momento',
    trustedBy: 'Semplice come inviare un messaggio',
  },

  howItWorks: {
    title: 'Come Funziona',
    subtitle: 'Tre modi per registrare. Zero fatica.',
    step1: {
      icon: '\u{1F4AC}',
      title: 'Testo',
      description: 'Scrivi naturalmente: "50 pranzo", "+500 stipendio", "uber ieri era lavoro"',
      example: '"85 supermercato"',
    },
    step2: {
      icon: '\u{1F4F8}',
      title: 'Foto',
      description: 'Invia la foto dello scontrino. L\'OCR estrae importo, negozio, P.IVA e articoli automaticamente.',
      example: 'Foto dello scontrino',
    },
    step3: {
      icon: '\u{1F3A4}',
      title: 'Audio',
      description: 'Registra un audio descrivendo la spesa. Trascriviamo e registriamo.',
      example: '"Ho speso 200 al distributore"',
    },
  },

  features: {
    title: 'Molto pi\u00F9 di un registro spese',
    subtitle: 'Strumenti potenti, interfaccia semplice',
    list: [
      {
        icon: 'wallet',
        title: 'Salvadanai (Portafogli)',
        description: 'Organizza per conto: UniCredit, Intesa, Progetto X. Ogni salvadanaio con la sua valuta.',
        command: '"crea salvadanaio UniCredit"',
      },
      {
        icon: 'target',
        title: 'Budget',
        description: 'Imposta limiti per categoria. Avviso quando raggiungi l\'80%.',
        command: '"budget 500 alimentari"',
      },
      {
        icon: 'hash',
        title: 'Tag',
        description: 'Usa gli #hashtag per organizzare: "50 uber #cliente #progetto-x"',
        command: '"le mie spese #lavoro"',
      },
      {
        icon: 'repeat',
        title: 'Ricorrenti',
        description: 'Configura spese fisse. Affitto, Netflix, stipendio - registrati automaticamente.',
        command: '"crea ricorrente 1500 affitto"',
      },
      {
        icon: 'globe',
        title: 'Multi-valuta',
        description: '\u20AC, \u00A3, $, CHF. Tassi aggiornati dalla BCE. Dashboard consolidata.',
        command: '"50 usd pranzo salvadanaio Viaggio"',
      },
      {
        icon: 'layout',
        title: 'Dashboard Web',
        description: 'Grafici, filtri, esportazione. Tutto ci\u00F2 che registri, visibile nel portale.',
        command: 'keepnota.com',
      },
    ],
  },

  commands: {
    title: 'Comandi Rapidi',
    subtitle: 'Conversazione naturale. Niente da memorizzare.',
    list: [
      { cmd: '50 caff\u00E8', desc: 'Registra una spesa di \u20AC50' },
      { cmd: '+2000 freelance', desc: 'Registra un\'entrata' },
      { cmd: 'riepilogo', desc: 'Mostra il riepilogo del mese' },
      { cmd: 'i miei salvadanai', desc: 'Elenca i tuoi portafogli' },
      { cmd: 'elimina ultimo', desc: 'Rimuove l\'ultima transazione' },
      { cmd: 'aiuto', desc: 'Elenca tutti i comandi' },
    ],
  },

  audience: {
    title: 'Fatto per chi vuole semplicit\u00E0',
    subtitle: 'Se usi WhatsApp, sai gi\u00E0 usare KeepNota',
    personas: [
      {
        icon: 'briefcase',
        title: 'Liberi Professionisti e P.IVA',
        description: 'Separa personale e lavoro. Sai esattamente quanto entra e quanto esce.',
      },
      {
        icon: 'user',
        title: 'Finanze Personali',
        description: 'Basta fogli Excel. Registra le spese nel momento in cui avvengono.',
      },
      {
        icon: 'users',
        title: 'Coppie e Famiglie',
        description: 'Salvadanai condivisi. Ognuno registra, tutti tengono traccia.',
      },
      {
        icon: 'plane',
        title: 'Viaggiatori',
        description: 'Multi-valuta automatico. Spese ovunque, tutto convertito.',
      },
    ],
  },

  comparison: {
    title: 'Perch\u00E9 KeepNota?',
    subtitle: 'Confronto con le alternative',
    vsSpreadsheet: {
      title: 'vs Foglio di Calcolo',
      points: [
        'Senza aprire il computer',
        'Registrazione istantanea',
        'Categorizza da solo',
        'Foto dello scontrino = tutto compilato',
      ],
    },
    vsApps: {
      title: 'vs App di Finanza',
      points: [
        'Funziona su WhatsApp (lo usi gi\u00E0 ogni giorno)',
        'Zero attriti - basta inviare un messaggio',
        'OCR degli scontrini incluso',
        'Niente notifiche fastidiose',
      ],
    },
    vsManual: {
      title: 'vs Annotare a Mano',
      points: [
        'Non dimentichi mai di registrare',
        'Audio quando non puoi digitare',
        'Storico sempre accessibile',
        'Report automatici',
      ],
    },
  },

  taxBonus: {
    title: 'Bonus: Pronto per la Dichiarazione dei Redditi',
    subtitle: 'Quando arriva il momento, i tuoi dati sono gi\u00E0 organizzati',
    points: [
      'Categorie mappate per le detrazioni fiscali',
      'P.IVA acquisita automaticamente dagli scontrini',
      'Report annuale esportabile',
      'Separa le spese deducibili con i tag',
    ],
  },

  pricing: {
    title: 'Piani',
    subtitle: 'Inizia gratis. Passa a Premium quando ne hai bisogno.',
    monthly: '/mese',
    yearly: '/anno',
    savePercent: 'Risparmia il 20%',
    basic: {
      name: 'Basic',
      price: '9,90',
      features: [
        '30 foto di scontrini/mese',
        '20 audio/mese',
        'Testi illimitati',
        'Dashboard e grafici base',
        'Report mensile',
        'Esporta CSV',
        'Conservazione scontrini: 1 anno',
      ],
    },
    pro: {
      name: 'Pro',
      price: '19,90',
      popular: 'Pi\u00F9 Popolare',
      features: [
        'Foto e audio illimitati',
        'Tutto del Basic +',
        'Grafici e filtri avanzati',
        'Confronto mese per mese',
        'Esporta PDF',
        'Report annuale (dichiarazione)',
        'Supporto prioritario',
        'Conservazione scontrini: 2 anni',
      ],
    },
    cta: 'Inizia Gratis',
    trial: '14 giorni gratis, cancella quando vuoi',
  },

  referral: {
    title: 'Invita e Guadagna',
    subtitle: 'Condividi con gli amici e ottieni giorni gratis',
    tiers: [
      { range: '1-5 inviti', reward: '7 giorni gratis ciascuno' },
      { range: '6-15 inviti', reward: '10 giorni gratis ciascuno' },
      { range: '16+ inviti', reward: '14 giorni + crediti' },
    ],
    cta: 'Scopri di pi\u00F9',
  },

  faq: {
    title: 'Domande Frequenti',
    items: [
      {
        q: 'Devo scaricare qualche app?',
        a: 'No! Funziona al 100% su WhatsApp. Basta salvare il nostro numero e iniziare a inviare le tue spese. Abbiamo anche un portale web per vedere grafici e report.',
      },
      {
        q: 'I miei dati sono al sicuro?',
        a: 'S\u00EC! Usiamo crittografia end-to-end, server sicuri e rispettiamo il GDPR. Puoi esportare o eliminare i tuoi dati in qualsiasi momento.',
      },
      {
        q: 'Posso cancellare quando voglio?',
        a: 'Certo! Nessun vincolo. Cancella in qualsiasi momento direttamente da WhatsApp digitando "cancella". I tuoi dati rimangono disponibili per 30 giorni dopo la cancellazione.',
      },
      {
        q: 'Funziona per liberi professionisti e P.IVA?',
        a: 'Perfetto per questo! Usa i salvadanai per separare conto personale e aziendale, i tag per i clienti, e avrai il controllo totale di entrate e uscite.',
      },
      {
        q: 'Come funziona l\'OCR degli scontrini?',
        a: 'Invia la foto dello scontrino o della ricevuta. La nostra IA estrae automaticamente: totale, nome del negozio, P.IVA, data e persino gli articoli. Basta verificare ed \u00E8 fatto.',
      },
      {
        q: 'Posso usare pi\u00F9 valute?',
        a: 'S\u00EC! Supportiamo Euro, Dollaro, Sterlina e Franco Svizzero. Ogni salvadanaio pu\u00F2 avere la sua valuta, e la dashboard mostra tutto convertito nella tua valuta principale.',
      },
    ],
  },

  cta: {
    title: 'Inizia a organizzare le tue finanze oggi',
    subtitle: '14 giorni gratis. Senza carta. Cancella quando vuoi.',
    button: 'Scrivici su WhatsApp',
    secondary: 'Guarda la demo',
  },

  footer: {
    copyright: '\u00A9 2025 KeepNota by Fig and Rosa Ltd. Tutti i diritti riservati.',
    terms: 'Termini di Servizio',
    privacy: 'Privacy',
    tagline: 'Gestione finanziaria via WhatsApp',
  },

  privacy: {
    title: 'Informativa sulla Privacy',
    lastUpdate: 'Ultimo aggiornamento: Dicembre 2024',
    intro: 'KeepNota ("noi", "nostro" o "Servizio") valorizza la privacy degli utenti. Questa Informativa sulla Privacy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni.',
    sections: [
      {
        title: '1. Dati che Raccogliamo',
        content: `Raccogliamo i seguenti dati quando utilizzi KeepNota:
\u2022 **Numero di telefono**: Per identificazione e comunicazione via WhatsApp
\u2022 **Messaggi inviati**: Testi, audio e immagini di scontrini che invii
\u2022 **Dati estratti**: Importi, categorie e informazioni degli scontrini elaborati
\u2022 **Dati di utilizzo**: Orari di accesso e interazioni con il servizio`,
      },
      {
        title: '2. Come Utilizziamo i Tuoi Dati',
        content: `Utilizziamo i tuoi dati per:
\u2022 Elaborare e organizzare i tuoi scontrini
\u2022 Generare report e grafici delle spese
\u2022 Identificare spese deducibili nella dichiarazione dei redditi
\u2022 Migliorare i nostri servizi e algoritmi di IA
\u2022 Inviare comunicazioni sul tuo account e sul servizio`,
      },
      {
        title: '3. Archiviazione e Sicurezza',
        content: `I tuoi dati sono archiviati in modo sicuro:
\u2022 Crittografia in transito (HTTPS/TLS)
\u2022 Archiviazione su server sicuri
\u2022 Accesso limitato solo ai sistemi automatizzati
\u2022 Backup regolari e ridondanza dei dati`,
      },
      {
        title: '4. Condivisione dei Dati',
        content: `**Non vendiamo i tuoi dati.** Li condividiamo solo con:
\u2022 **Fornitori di servizi**: Elaborazione pagamenti (Stripe), archiviazione (AWS)
\u2022 **IA/ML**: Google (Gemini) per l'elaborazione di immagini e testo - dati anonimizzati
\u2022 **Obbligo legale**: Quando richiesto dalla legge o da un'ordinanza del tribunale`,
      },
      {
        title: '5. I Tuoi Diritti (GDPR)',
        content: `Hai diritto a:
\u2022 **Accesso**: Richiedere una copia dei tuoi dati
\u2022 **Rettifica**: Correggere dati inesatti
\u2022 **Cancellazione**: Richiedere la cancellazione dei tuoi dati
\u2022 **Portabilit\u00E0**: Ricevere i tuoi dati in formato strutturato
\u2022 **Revoca**: Revocare il consenso in qualsiasi momento

Per esercitare i tuoi diritti, invia un messaggio al nostro WhatsApp o email: privacy@keepnota.com`,
      },
      {
        title: '6. Conservazione dei Dati',
        content: `Conserviamo i tuoi dati finch\u00E9 il tuo account \u00E8 attivo. Dopo la cancellazione:
\u2022 Dati finanziari: Conservati per 5 anni (obbligo fiscale)
\u2022 Immagini degli scontrini: Eliminate entro 30 giorni
\u2022 Dati dell'account: Eliminati entro 30 giorni`,
      },
      {
        title: '7. Contatti',
        content: `Per domande sulla privacy:
\u2022 Email: privacy@keepnota.com
\u2022 WhatsApp: Invia "PRIVACY" al nostro numero`,
      },
    ],
  },

  feedback: {
    title: 'Invia il tuo Feedback',
    subtitle: 'La tua opinione ci aiuta a migliorare KeepNota',
    typeLabel: 'Tipo di feedback',
    types: {
      general: 'Generale',
      feature_request: 'Suggerimento',
      bug: 'Bug/Errore',
      complaint: 'Reclamo',
      praise: 'Complimento',
      account_deletion: 'Elimina account',
    },
    messageLabel: 'Il tuo messaggio',
    messagePlaceholder: 'Dicci cosa ne pensi...',
    ratingLabel: 'Valutazione (opzionale)',
    nameLabel: 'Il tuo nome (opzionale)',
    namePlaceholder: 'Come possiamo chiamarti?',
    emailLabel: 'Email (opzionale)',
    emailPlaceholder: 'tua@email.com',
    emailHint: 'Per rispondere al tuo feedback',
    submit: 'Invia Feedback',
    errors: {
      messageRequired: 'Per favore, scrivi un messaggio',
      messageTooShort: 'Messaggio troppo corto (minimo 10 caratteri)',
      submitFailed: 'Errore nell\'invio. Riprova.',
    },
    success: {
      title: 'Feedback inviato!',
      message: 'Grazie per aver condiviso la tua opinione. Lo analizzeremo con attenzione.',
    },
    backToHome: 'Torna alla pagina iniziale',
  },

  terms: {
    title: 'Termini di Servizio',
    lastUpdate: 'Ultimo aggiornamento: Dicembre 2024',
    intro: 'Utilizzando KeepNota, accetti questi Termini di Servizio. Leggili attentamente.',
    sections: [
      {
        title: '1. Informazioni sul Servizio',
        content: `KeepNota \u00E8 un servizio di organizzazione di scontrini e spese via WhatsApp. Offriamo:
\u2022 Elaborazione automatica di scontrini tramite foto, audio o testo
\u2022 Categorizzazione e organizzazione delle spese
\u2022 Report e grafici delle spese
\u2022 Identificazione delle spese deducibili nella dichiarazione dei redditi

Il servizio \u00E8 fornito "cos\u00EC com'\u00E8" e pu\u00F2 essere modificato in qualsiasi momento.`,
      },
      {
        title: '2. Registrazione e Account',
        content: `Per utilizzare KeepNota:
\u2022 Devi avere almeno 18 anni
\u2022 Fornire informazioni veritiere
\u2022 Mantenere aggiornato il tuo numero di telefono
\u2022 Non condividere l'accesso con terzi

Sei responsabile di tutte le attivit\u00E0 sul tuo account.`,
      },
      {
        title: '3. Uso Accettabile',
        content: `Accetti di NON:
\u2022 Utilizzare il servizio per scopi illegali
\u2022 Inviare contenuti offensivi, diffamatori o illegali
\u2022 Tentare di accedere a sistemi o dati di altri utenti
\u2022 Utilizzare bot o automazione non autorizzata
\u2022 Rivendere o ridistribuire il servizio`,
      },
      {
        title: '4. Pagamenti e Abbonamento',
        content: `\u2022 Offriamo un periodo di prova gratuito di 14 giorni
\u2022 Dopo la prova, l'abbonamento viene addebitato mensilmente
\u2022 Pagamenti elaborati tramite Stripe (carta di credito)
\u2022 La cancellazione pu\u00F2 essere effettuata in qualsiasi momento
\u2022 Non sono previsti rimborsi per periodi parziali`,
      },
      {
        title: '5. Propriet\u00E0 Intellettuale',
        content: `\u2022 KeepNota e i suoi componenti sono propriet\u00E0 di Figrosa
\u2022 Mantieni la propriet\u00E0 dei tuoi dati e scontrini
\u2022 Ti concediamo una licenza limitata per utilizzare il servizio
\u2022 Ci concedi la licenza per elaborare i tuoi dati secondo necessit\u00E0`,
      },
      {
        title: '6. Limitazione di Responsabilit\u00E0',
        content: `\u2022 KeepNota non sostituisce la consulenza contabile o fiscale
\u2022 Non garantiamo precisione assoluta nell'elaborazione degli scontrini
\u2022 Non siamo responsabili per decisioni fiscali basate sul servizio
\u2022 La nostra responsabilit\u00E0 \u00E8 limitata all'importo pagato per il servizio`,
      },
      {
        title: '7. Cancellazione',
        content: `Puoi cancellare in qualsiasi momento:
\u2022 Invia "CANCELLA" via WhatsApp
\u2022 Accedi al tuo account nel portale
\u2022 L'accesso continua fino alla fine del periodo pagato
\u2022 I tuoi dati saranno eliminati secondo la nostra Informativa sulla Privacy`,
      },
      {
        title: '8. Modifiche ai Termini',
        content: `Possiamo modificare questi termini in qualsiasi momento. Ti informeremo tramite:
\u2022 Messaggio su WhatsApp
\u2022 Email (se registrata)
\u2022 Avviso nel portale

L'uso continuato dopo le modifiche costituisce accettazione.`,
      },
      {
        title: '9. Contatti',
        content: `Per domande sui Termini:
\u2022 Email: supporto@keepnota.com
\u2022 WhatsApp: Invia "AIUTO" al nostro numero`,
      },
    ],
  },
};
